import Reveal from "@/components/Reveal";

export default function Problem() {
  return (
    <section id="problema" data-testid="problem-section" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#0a0a0a] to-[#050505]" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <Reveal className="lg:col-span-5">
            <div className="font-stencil text-xs text-[#00A0A0] tracking-widest mb-4">01 / EL PROBLEMA</div>
            <h2 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl uppercase tracking-tight leading-[0.95]">
              EL PROBLEMA
              <br />
              <span className="text-white/35">NO ES QUE NO</span>
              <br />
              <span className="font-stencil text-[#FFD700]">VENDAS.</span>
            </h2>
          </Reveal>

          <Reveal delay={150} className="lg:col-span-7 lg:pl-8">
            <p className="text-lg lg:text-2xl text-white/75 leading-relaxed font-body">
              La mayoría de compra-ventas ya hacen anuncios y publican en redes. Pero los contactos llegan{" "}
              <span className="text-white">fríos</span>: comparando precio, sin conocerte y sin una razón real
              para elegirte a ti antes que al de al lado.
            </p>

            <div className="my-10 h-px bg-gradient-to-r from-[#00A0A0]/50 via-[#FFD700]/30 to-transparent" />

            <p className="text-lg lg:text-2xl text-white/85 leading-relaxed font-body">
              La venta no empieza en la llamada.{" "}
              <span className="text-white">Empieza semanas antes</span>, cuando el cliente ya te ha visto trabajar y confía en ti.
            </p>

            <p className="mt-8 text-lg lg:text-xl text-white/60 leading-relaxed font-body">
              Por eso no vendemos anuncios sueltos. Combinamos{" "}
              <span className="font-stencil text-[#00A0A0]">CONTENIDO</span> +{" "}
              <span className="font-stencil text-[#00A0A0]">MARCA</span> +{" "}
              <span className="font-stencil text-[#00A0A0]">POSICIONAMIENTO</span> +{" "}
              <span className="font-stencil text-[#00A0A0]">CAPTACIÓN</span> para que, cuando alguien te escriba,{" "}
              <span className="text-white">ya quiera elegirte</span>.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
